import React from 'react';

// Classnames
import clsx from 'clsx';

export const LicensingInformation: React.FC<{ className?: string }> = ({ className }) => {
	const cnWrapper = clsx(
		"licensing-information mb5",
		className ? className : ""
	);

	return (
		<div className={cnWrapper}>
			<h4 className="mb10">Licensing Information</h4>
			<p>Sold for research purposes under agreement from Pfizer Inc.</p>
		</div>
	);
};

export default LicensingInformation;